import React from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import Logo from "../../assets/images/logo.png";

import CaseStudiesIcon from "../../assets/shopping-bag.svg";
import HowItWorksIcon from "../../assets/request-icon.png";
import LoginIcon from "../../assets/profile-icon.png";

const PartnerSidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const goToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const sidebarContent = (
    <div className="mt-[32px] h-auto sidebar-menu">
      <button
        onClick={() => {
          goToSection("case-studies");
          setSidebarOpen(false);
        }}
        className="flex justify-between items-center hover:bg-[#D0ADFB20] mb-[16px] py-[8px] rounded-lg w-full font-normal text-white transition-all"
      >
        <div className="flex justify-start items-center gap-[12px]">
          <img src={CaseStudiesIcon} className="w-[30px] h-[30px]" alt="Case studies" />
          <p className="text-[16px]">Case studies</p>
        </div>
      </button>

      <button
        onClick={() => {
          goToSection("how-it-works");
          setSidebarOpen(false);
        }}
        className="flex justify-between items-center hover:bg-[#D0ADFB20] mb-[16px] py-[8px] rounded-lg w-full font-normal text-white transition-all"
      >
        <div className="flex justify-start items-center gap-[12px]">
          <img src={HowItWorksIcon} className="w-[30px] h-[30px]" alt="How it works" />
          <p className="text-[16px]">Hoe het werkt</p>
        </div>
      </button>

      <Link
        to="/login"
        className="flex justify-between items-center hover:bg-[#D0ADFB20] mb-[16px] py-[8px] rounded-lg w-full font-normal text-white transition-all"
      >
        <div className="flex justify-start items-center gap-[12px]">
          <img src={LoginIcon} className="w-[30px] h-[30px]" alt="Login" />
          <p className="text-[16px]">Inloggen</p>
        </div>
      </Link>

      <button
        onClick={() => {
          goToSection("signup");
          setSidebarOpen(false);
        }}
        className="flex justify-center items-center mt-[24px] border-[#7721E5] border-[1.5px] rounded-[6px] w-full h-[52px] font-semibold text-[16px] text-white premium-button"
      >
        Meld je aan als partner
      </button>
    </div>
  );

  return (
    <div className="lg:hidden">
      {/* Mobile Sidebar Drawer */}
      <div
        className={`fixed inset-0 z-[1000000] transition-opacity duration-300 ${
          sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        {/* Backdrop */}
        <div
          className="absolute inset-0 bg-[#000000]"
          onClick={() => setSidebarOpen(false)}
        />

        {/* Sidebar */}
        <div
          className={`p-[32px_24px] fixed top-0 left-0 h-full w-[100vw] bg-[#000000] transform transition-transform duration-300 ease-in-out ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="z-[1000000] relative h-full">
            {/* Close button */}
            <div className="flex justify-between items-center w-full">
              <button
                onClick={() => setSidebarOpen(false)}
                className="text-white"
              >
                <Icon icon="heroicons:x-mark" className="w-[30px] h-[30px]" />
              </button>

              <button
                onClick={() => setSidebarOpen(false)}
                className="flex justify-center items-center gap-2"
              >
                <img src={Logo} className="-mt-1 w-auto h-[14px]" alt="logo" />
                <div className="font-semibold text-[16px] text-white uppercase tracking-wide">
                  FOR PARTNERS
                </div>
              </button>
              <div className="w-[20px]"></div>
            </div>

            {/* Sidebar content */}
            <div className="flex-1 overflow-y-auto">{sidebarContent}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerSidebar;
